export const convertUnicodeHexToString = (hexString: string) => {
  return hexString.replaceAll(/&#x([0-9A-Fa-f]+);/g, (_match, hex) => {
    return String.fromCharCode(parseInt(hex, 16));
  });
};
